var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all2) => {
  __markAsModule(target);
  for (var name in all2)
    __defProp(target, name, { get: all2[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  addFunction: () => addFunction,
  appendMatrixFunction: () => appendMatrixFunction,
  buildMatrixTextFunction: () => buildMatrixTextFunction,
  calculateGravamenFunction: () => calculateGravamenFunction,
  concatenateFunction: () => concatenateFunction,
  containTextFunction: () => containTextFunction,
  dateCalculateDaysFunction: () => dateCalculateDaysFunction,
  dateHumanizeFunction: () => dateHumanizeFunction,
  dateReverseFunction: () => dateReverseFunction,
  divideFunction: () => divideFunction,
  elementMatrixFunction: () => elementMatrixFunction,
  emptyFunction: () => emptyFunction,
  equalFunction: () => equalFunction,
  equalTextFunction: () => equalTextFunction,
  floorFunction: () => floorFunction,
  ifThenFunction: () => ifThenFunction,
  includeEqualTextFunction: () => includeEqualTextFunction,
  includeTextFunction: () => includeTextFunction,
  indexFirstTextValueFunction: () => indexFirstTextValueFunction,
  indexFunction: () => indexFunction,
  indexMaximumFunction: () => indexMaximumFunction,
  indexMinimumFunction: () => indexMinimumFunction,
  indexSumFunction: () => indexSumFunction,
  largerEqFunction: () => largerEqFunction,
  largerFunction: () => largerFunction,
  leftNumberFunction: () => leftNumberFunction,
  leftTextFunction: () => leftTextFunction,
  logicFunction: () => logicFunction,
  matchNumberFunction: () => matchNumberFunction,
  matchTextFunction: () => matchTextFunction,
  maximumFunction: () => maximumFunction,
  minimumFunction: () => minimumFunction,
  modeFunction: () => modeFunction,
  multiplyFunction: () => multiplyFunction,
  notContainTextFunction: () => notContainTextFunction,
  notEmptyFunction: () => notEmptyFunction,
  notIncludeEqualTextFunction: () => notIncludeEqualTextFunction,
  notIncludeTextFunction: () => notIncludeTextFunction,
  parseNameFunction: () => parseNameFunction,
  percentageFunction: () => percentageFunction,
  positionFunction: () => positionFunction,
  removeEmptiesFunction: () => removeEmptiesFunction,
  rightNumberFunction: () => rightNumberFunction,
  rightTextFunction: () => rightTextFunction,
  roundFunction: () => roundFunction,
  roundIntegerFunction: () => roundIntegerFunction,
  sanitizeFunction: () => sanitizeFunction,
  smallerEqFunction: () => smallerEqFunction,
  smallerFunction: () => smallerFunction,
  subtractFunction: () => subtractFunction,
  summatoryMatrixFunction: () => summatoryMatrixFunction,
  unequalFunction: () => unequalFunction,
  unequalTextFunction: () => unequalTextFunction,
  uniqueFunction: () => uniqueFunction
});
var import_mathjs = __toModule(require("mathjs"));
var import_moment = __toModule(require("moment"));
var import_utils = __toModule(require("../../../../../engine/utils"));
var import_mathFunctionError = __toModule(require("../../../../../error/mathFunctionError"));
var import_utils2 = __toModule(require("./utils"));
const math = (0, import_mathjs.create)(import_mathjs.all);
const addFunction = (...values) => {
  const sanitizedValues = (0, import_utils2.sanitizeNumber)(values, 2);
  return math.add(...sanitizedValues);
};
const appendMatrixFunction = (fillValue, matrix, number) => {
  let baseMatrix = [];
  if ((0, import_utils.isEmpty)(matrix)) {
    baseMatrix.push(fillValue);
  } else if (!Array.isArray(matrix)) {
    baseMatrix.push(matrix);
  } else {
    baseMatrix = baseMatrix.concat(matrix);
  }
  if ((0, import_utils.isEmpty)(number)) {
    baseMatrix.push(fillValue);
  } else if (!Array.isArray(number)) {
    baseMatrix.push(number);
  } else {
    baseMatrix = baseMatrix.concat(number);
  }
  return baseMatrix;
};
const buildMatrixTextFunction = (stringValue) => {
  if (typeof stringValue !== "string") {
    throw new import_mathFunctionError.MathFunctionError(`Function buildMatrixText. value error type: ${typeof stringValue}`);
  }
  const values = stringValue.split(",");
  return (0, import_utils2.sanitizeString)(values);
};
const truncateFunction = function(num, places) {
  return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
};
const calculateGravamenFunction = (math2, taxBase, range, taxForRange, roundFunctionArg = import_utils.roundNumber, truncateAndRoundRange = false, roundGravamen = false) => {
  let gravamen = 0;
  let localTaxBase = taxBase;
  for (let i = 1; i < range.length; i += 1) {
    const rangeValueRaw = range[i] - range[i - 1];
    const rangeValue = truncateAndRoundRange ? truncateFunction(rangeValueRaw, 2) : rangeValueRaw;
    const tax = taxForRange[i - 1];
    if (localTaxBase - rangeValue >= 0) {
      gravamen += rangeValue * tax;
      gravamen = roundGravamen ? (0, import_utils.roundNumber)(gravamen) : gravamen;
    } else {
      gravamen += (0, import_utils.roundNumber)(localTaxBase * tax);
    }
    localTaxBase = (0, import_utils.roundNumber)(Math.max(localTaxBase - rangeValue, 0));
  }
  if (localTaxBase > 0) {
    gravamen += (0, import_utils.roundNumber)(localTaxBase * taxForRange[taxForRange.length - 1]);
  }
  return roundFunctionArg(gravamen);
};
const concatenateFunction = (...values) => {
  const sanitizedValues = (0, import_utils2.sanitizeString)(values);
  return sanitizedValues.reduce((acc, next) => `${acc}${next}`, import_utils2.ARG.SCALAR.STRING);
};
const dateHumanizeFunction = (date) => {
  if (!date) {
    return import_utils2.ARG.SCALAR.STRING;
  } else if (date && (typeof date !== "string" || date.length !== 8)) {
    throw new import_mathFunctionError.MathFunctionError(`Function dateHumanize. Unknown date format: ${date}`);
  }
  return `${date.substring(0, 2)}/${date.substring(2, 4)}/${date.substring(4, 8)}`;
};
const dateReverseFunction = (date) => {
  if (!date) {
    return import_utils2.ARG.SCALAR.STRING;
  } else if (date && (typeof date !== "string" || date.length !== 8)) {
    throw new import_mathFunctionError.MathFunctionError(`Function dateReverse. Unknown date format: ${date}`);
  }
  return `${date.substring(6, 8)}${date.substring(4, 6)}${date.substring(0, 4)}`;
};
const dateCalculateDaysFunction = (date1, date2) => {
  if (!date1 || !date2) {
    return 0;
  }
  const momentDate1 = (0, import_moment.default)(date1, "DDMMYYYY");
  const momentDate2 = (0, import_moment.default)(date2, "DDMMYYYY");
  const daysDiff = momentDate2.diff(momentDate1, "days");
  if (daysDiff < 0) {
    throw new import_mathFunctionError.MathFunctionError(`Function dateCalculateDays. First date ${date1} is greater than second date ${date2}`);
  }
  return daysDiff + 1;
};
const divideFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.sanitizeNumber)(value1);
  const sanitizedValue2 = (0, import_utils2.sanitizeNumber)(value2);
  if (!sanitizedValue2) {
    return sanitizedValue1;
  }
  return sanitizedValue1 / sanitizedValue2;
};
const elementMatrixFunction = (fillValue, matrix, position) => {
  if (!matrix) {
    return fillValue;
  }
  if (!Array.isArray(matrix)) {
    if (position === 1) {
      return fillValue + matrix;
    }
    return fillValue;
  }
  if (position < 1 || position > matrix.length || !matrix[position - 1]) {
    return fillValue;
  }
  return fillValue + matrix[position - 1];
};
const emptyFunction = (value) => {
  if (value === void 0) {
    return true;
  } else if (typeof value !== "string" || value === "") {
    return true;
  }
  return false;
};
const equalFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.sanitizeNumber)(value1);
  const sanitizedValue2 = (0, import_utils2.sanitizeNumber)(value2);
  return math.equal(sanitizedValue1, sanitizedValue2);
};
const equalTextFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.sanitizeString)(value1);
  const sanitizedValue2 = (0, import_utils2.sanitizeString)(value2);
  return math.equalText(sanitizedValue1, sanitizedValue2);
};
const floorFunction = (value) => {
  const sanitizedValue = (0, import_utils2.sanitizeNumber)(value);
  return math.floor(sanitizedValue);
};
const containTextFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.uppercaseString)((0, import_utils2.sanitizeString)(value1));
  const sanitizedValue2 = (0, import_utils2.uppercaseString)((0, import_utils2.sanitizeString)(value2));
  if (Array.isArray(sanitizedValue1) && Array.isArray(sanitizedValue2)) {
    if (sanitizedValue1.length !== sanitizedValue2.length) {
      throw new import_mathFunctionError.MathFunctionError(`Function containText. Arrays must have the same length`);
    }
    return sanitizedValue1.map((value, index) => value.includes(sanitizedValue2[index]));
  }
  if (Array.isArray(sanitizedValue1)) {
    return sanitizedValue1.map((value) => value.includes(sanitizedValue2));
  }
  if (Array.isArray(sanitizedValue2)) {
    return sanitizedValue2.map((value) => sanitizedValue1.includes(value));
  }
  return sanitizedValue1.includes(sanitizedValue2);
};
const notContainTextFunction = (value1, value2) => {
  return !containTextFunction(value1, value2);
};
const ifThenFunction = (condition, value) => {
  return condition ? value : void 0;
};
const includeFunction = (valueA, valueB, compareFunction) => {
  if (!Array.isArray(valueB)) {
    throw new import_mathFunctionError.MathFunctionError(`Function include error, value ${JSON.stringify(valueB)} is not an array`);
  }
  if (!Array.isArray(valueA)) {
    let len = valueB.length;
    while (len--) {
      if (compareFunction(valueA, valueB[len])) {
        return true;
      }
    }
    return false;
  }
  return valueA.map((value) => {
    let len = valueB.length;
    while (len--) {
      if (compareFunction(value, valueB[len])) {
        return true;
      }
    }
    return false;
  });
};
const includeTextFunction = (valueA, valueB) => {
  return includeFunction(valueA, valueB, containTextFunction);
};
const includeEqualTextFunction = (valueA, valueB) => {
  return includeFunction(valueA, valueB, equalTextFunction);
};
const notIncludeTextFunction = (valueA, valueB) => {
  const result = includeTextFunction(valueA, valueB);
  return Array.isArray(result) ? result.map((value) => !value) : !result;
};
const notIncludeEqualTextFunction = (valueA, valueB) => {
  const result = includeEqualTextFunction(valueA, valueB);
  return Array.isArray(result) ? result.map((value) => !value) : !result;
};
const largerFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.sanitizeNumber)(value1);
  const sanitizedValue2 = (0, import_utils2.sanitizeNumber)(value2);
  return math.larger(sanitizedValue1, sanitizedValue2);
};
const largerEqFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.sanitizeNumber)(value1);
  const sanitizedValue2 = (0, import_utils2.sanitizeNumber)(value2);
  return math.largerEq(sanitizedValue1, sanitizedValue2);
};
const leftNumberFunction = (value, count) => {
  const sanitizedValue = (0, import_utils2.sanitizeString)(value);
  const countValue = (0, import_utils2.getCountValue)(count, sanitizedValue);
  const result = parseInt(sanitizedValue.substring(0, countValue), 10);
  return Number.isNaN(result) ? 0 : result;
};
const leftTextFunction = (value, count) => {
  const sanitizedValue = (0, import_utils2.sanitizeString)(value);
  const countValue = (0, import_utils2.getCountValue)(count, sanitizedValue);
  return sanitizedValue.substring(0, countValue);
};
const smallerFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.sanitizeNumber)(value1);
  const sanitizedValue2 = (0, import_utils2.sanitizeNumber)(value2);
  return math.smaller(sanitizedValue1, sanitizedValue2);
};
const smallerEqFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.sanitizeNumber)(value1);
  const sanitizedValue2 = (0, import_utils2.sanitizeNumber)(value2);
  return math.smallerEq(sanitizedValue1, sanitizedValue2);
};
const logicFunction = (operator, ...operands) => {
  if (operator === "and") {
    return operands.reduce((acc, next) => {
      if (Array.isArray(next) && !Array.isArray(acc)) {
        return math.and(next, acc);
      }
      return math.and(acc, next);
    });
  } else {
    return operands.reduce((acc, next) => {
      if (Array.isArray(next) && !Array.isArray(acc)) {
        return math.or(next, acc);
      }
      return math.or(acc, next);
    });
  }
};
const maximumFunction = (...values) => {
  const sanitizedValues = (0, import_utils2.sanitizeNumber)(values, 2);
  return Number(Math.max(...sanitizedValues));
};
const minimumFunction = (...values) => {
  const sanitizedValues = (0, import_utils2.sanitizeNumber)(values, 2);
  return Number(Math.min(...sanitizedValues));
};
const multiplyFunction = (...values) => {
  const sanitizedValues = (0, import_utils2.sanitizeNumber)(values, 2);
  return math.multiply(...sanitizedValues);
};
const modeFunction = (values) => {
  if (!Array.isArray(values)) {
    return values;
  }
  const result = {};
  const originalValues = {};
  values.forEach((value) => {
    if (!result[value]) {
      result[value] = 1;
      originalValues[value] = value;
      return;
    }
    result[value] += 1;
  });
  const key = Object.keys(result).sort((a, b) => result[b] - result[a])[0];
  return originalValues[key];
};
const notEmptyFunction = (value) => {
  return !emptyFunction(value);
};
const parseNameBacktrack = (words, breakChar, expectedLength, last = "") => {
  const previous = words.pop();
  const concatenatedName = `${previous}${breakChar}${last}`;
  if (concatenatedName.length > expectedLength) {
    return last.trim();
  }
  return parseNameBacktrack(words, breakChar, expectedLength, concatenatedName);
};
const BREAK_CHAR = " ";
const NAME_LENGTH = 15;
const parseNameFunction = (value) => {
  if (value && typeof value !== "string") {
    throw new import_mathFunctionError.MathFunctionError(`Function parseName. Text is not a string '${value}'`);
  } else if (!value) {
    return "";
  }
  const words = value.trim().split(BREAK_CHAR);
  if (words.length <= 3) {
    const name = words[words.length - 1];
    return name.substring(0, NAME_LENGTH).trim();
  } else {
    words.splice(0, 2);
    if (words[words.length - 1].length > NAME_LENGTH) {
      return words[words.length - 1].substring(0, NAME_LENGTH);
    }
    return parseNameBacktrack(words, BREAK_CHAR, NAME_LENGTH);
  }
};
const percentageFunction = (value, divisor) => {
  const sanitizedValue = parseFloat(value);
  const sanitizedDivisor = parseFloat(divisor);
  if (Number.isNaN(sanitizedValue)) {
    throw new import_mathFunctionError.MathFunctionError(`Function percentage. Value is not a number '${value}'`);
  }
  if (Number.isNaN(sanitizedDivisor)) {
    throw new import_mathFunctionError.MathFunctionError(`Function percentage. Divisor is not a number '${divisor}'`);
  }
  return (0, import_utils.roundNumber)(Math.floor(1e4 * (sanitizedValue / sanitizedDivisor)) / 100);
};
const removeEmptiesFunction = (values) => {
  if (!Array.isArray(values)) {
    throw new import_mathFunctionError.MathFunctionError(`Function removeEmptiesFunction. ${values} should be matrix`);
  }
  return values.filter((value) => notEmptyFunction(value));
};
const rightNumberFunction = (value, count) => {
  const sanitizedValue = (0, import_utils2.sanitizeNumber)(value);
  const countValue = (0, import_utils2.getCountValue)(count, sanitizedValue);
  const result = parseInt(`${sanitizedValue}`.slice(-countValue), 10);
  return Number.isNaN(result) ? import_utils2.ARG.SCALAR.NUMBER : result;
};
const rightTextFunction = (value, count) => {
  const sanitizedValue = (0, import_utils2.sanitizeString)(value);
  const countValue = (0, import_utils2.getCountValue)(count, sanitizedValue);
  const result = sanitizedValue.slice(-countValue);
  return result;
};
const roundFunction = (value) => {
  const sanitizedValue = (0, import_utils2.sanitizeNumber)(value);
  return (0, import_utils.roundNumber)(sanitizedValue);
};
const roundIntegerFunction = (value) => {
  const sanitizedValue = (0, import_utils2.sanitizeNumber)(value);
  return (0, import_utils.roundNumber)(sanitizedValue, 0, true);
};
const subtractFunction = (value1, value2) => {
  const sanitizedValue1 = (0, import_utils2.sanitizeNumber)(value1);
  const sanitizedValue2 = (0, import_utils2.sanitizeNumber)(value2);
  if (!sanitizedValue2) {
    return sanitizedValue1;
  }
  return sanitizedValue1 - sanitizedValue2;
};
const summatoryMatrixFunction = (matrix) => {
  const sanitizedMatrix = (0, import_utils2.sanitizeNumber)(matrix);
  if (!Array.isArray(matrix)) {
    return matrix;
  }
  return (0, import_utils.roundNumber)(math.sum(sanitizedMatrix));
};
const unequalFunction = (valueA, valueB) => {
  const sanitizedValueA = (0, import_utils2.sanitizeNumber)(valueA);
  const sanitizedValueB = (0, import_utils2.sanitizeNumber)(valueB);
  return math.unequal(sanitizedValueA, sanitizedValueB);
};
const unequalTextFunction = (valueA, valueB) => {
  const sanitizedValueA = (0, import_utils2.sanitizeString)(valueA);
  const sanitizedValueB = (0, import_utils2.sanitizeString)(valueB);
  return !math.equalText(sanitizedValueA, sanitizedValueB);
};
const matchFunction = (valueA, valueB, compareFunction) => {
  if (Array.isArray(valueB) && valueB.length !== 1) {
    throw new import_mathFunctionError.MathFunctionError(`Function match error, value ${JSON.stringify(valueB)} is of invalid length ${valueB.length}`);
  }
  const valueBScalar = Array.isArray(valueB) ? valueB[0] : valueB;
  if (!Array.isArray(valueA)) {
    if (compareFunction(valueA, valueBScalar)) {
      return [1];
    }
    return [0];
  }
  const matches = valueA.reduce((acc, elementA, index) => {
    if (compareFunction(elementA, valueBScalar)) {
      acc.push(index + 1);
      return acc;
    }
    return acc;
  }, []);
  if (matches.length === 0) {
    return [0];
  }
  return matches;
};
const matchNumberFunction = (valueA, valueB) => {
  return matchFunction(valueA, valueB, equalFunction);
};
const matchTextFunction = (valueA, valueB) => {
  return matchFunction(valueA, valueB, equalTextFunction);
};
const sanitizeFunction = (value) => {
  const valueType = typeof value;
  if (valueType !== "string" && valueType !== "undefined" && value !== null) {
    throw new import_mathFunctionError.MathFunctionError(`Function sanitizeFunction. Invalid value type: ${valueType}`);
  }
  const sanitizedValue = (0, import_utils2.sanitizeString)(value);
  return sanitizedValue.trim().replace(/\s\s+/g, " ");
};
const indexFirstTextValueFunction = (valueA, valueB) => {
  const indexValues = indexFunction(valueA, valueB);
  const firstValue = indexValues[0];
  const sanitizedValue = (0, import_utils2.sanitizeString)(firstValue);
  return sanitizedValue.trim().replace(/\s\s+/g, " ");
};
const indexFunction = (valueA, valueB) => {
  if (!Array.isArray(valueB)) {
    throw new import_mathFunctionError.MathFunctionError(`Function indexFunction. Invalid indexes: ${valueB} should be matrix`);
  }
  if (!Array.isArray(valueA)) {
    if (valueB.length !== 1) {
      const valueBString = JSON.stringify(valueB);
      throw new import_mathFunctionError.MathFunctionError(`Function indexFunction. Invalid indexes: ${valueBString} for given value ${valueA}`);
    }
    if (valueB[0] === 1) {
      return [valueA];
    }
    return [];
  }
  return valueB.map((elementB) => {
    if (elementB > valueA.length) {
      const valueAString = JSON.stringify(valueA);
      throw new import_mathFunctionError.MathFunctionError(`Function indexFunction. Invalid index: ${elementB} for element: ${valueAString} of length ${valueA.length}`);
    }
    return elementB === 0 ? void 0 : valueA[elementB - 1];
  });
};
const indexMaximumFunction = (valueA, valueB) => {
  const indexValues = indexFunction(valueA, valueB);
  return maximumFunction(...indexValues);
};
const indexMinimumFunction = (valueA, valueB) => {
  const indexValues = indexFunction(valueA, valueB);
  if (indexValues.length === 1) {
    return (0, import_utils2.sanitizeNumber)(indexValues[0]);
  }
  return minimumFunction(...indexValues);
};
const indexSumFunction = (valueA, valueB) => {
  const indexValues = indexFunction(valueA, valueB);
  return addFunction(...indexValues);
};
const positionFunction = (value) => {
  if (!Array.isArray(value)) {
    throw new import_mathFunctionError.MathFunctionError(`Function positionFunction. ${value} should be matrix`);
  }
  return value.map((value2, index) => index + 1);
};
const uniqueFunction = (value) => {
  if (!Array.isArray(value)) {
    throw new import_mathFunctionError.MathFunctionError(`Function uniqueFunction. ${value} should be matrix`);
  }
  return [...new Set(value)];
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  addFunction,
  appendMatrixFunction,
  buildMatrixTextFunction,
  calculateGravamenFunction,
  concatenateFunction,
  containTextFunction,
  dateCalculateDaysFunction,
  dateHumanizeFunction,
  dateReverseFunction,
  divideFunction,
  elementMatrixFunction,
  emptyFunction,
  equalFunction,
  equalTextFunction,
  floorFunction,
  ifThenFunction,
  includeEqualTextFunction,
  includeTextFunction,
  indexFirstTextValueFunction,
  indexFunction,
  indexMaximumFunction,
  indexMinimumFunction,
  indexSumFunction,
  largerEqFunction,
  largerFunction,
  leftNumberFunction,
  leftTextFunction,
  logicFunction,
  matchNumberFunction,
  matchTextFunction,
  maximumFunction,
  minimumFunction,
  modeFunction,
  multiplyFunction,
  notContainTextFunction,
  notEmptyFunction,
  notIncludeEqualTextFunction,
  notIncludeTextFunction,
  parseNameFunction,
  percentageFunction,
  positionFunction,
  removeEmptiesFunction,
  rightNumberFunction,
  rightTextFunction,
  roundFunction,
  roundIntegerFunction,
  sanitizeFunction,
  smallerEqFunction,
  smallerFunction,
  subtractFunction,
  summatoryMatrixFunction,
  unequalFunction,
  unequalTextFunction,
  uniqueFunction
});
